function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "System Icon /Copy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Explorer-Desktop@1440px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "05-Order-Detail_Open",
  transform: "translate(-436.000000, -296.000000)",
  fill: "#073C50"
}, React.createElement("g", {
  id: "ID",
  transform: "translate(24.000000, 258.000000)"
}, React.createElement("g", {
  id: "System-Icon-/Copy",
  transform: "translate(412.000000, 38.000000)"
}, React.createElement("path", {
  d: "M12,0 L12,8.5 L8.5,8.5 L8.5,12 L0,12 L0,3.5 L3.5,3.5 L3.5,0 L12,0 Z M7,5 L1.5,5 L1.5,10.5 L7,10.5 L7,5 Z M10.5,1.5 L5,1.5 L5,3.5 L8.5,3.5 L8.5,7 L10.5,7 L10.5,1.5 Z",
  id: "Copy"
})))));

var SvgCopyIconDark = function SvgCopyIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopyIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CopyIconDark.27fad849.svg";
export { ForwardRef as ReactComponent };